"use client";

import Script from "next/script";

export default function AmplitudeSnippet() {
  const onLoad = () => {
    window.amplitude.add(window.sessionReplay.plugin({ sampleRate: 1 }));
    window.amplitude.init("771ef962eeb76c9a8545d7c50f9ca8f", {
      fetchRemoteConfig: true,
      autocapture: true,
    });
  };

  return (
    <>
      <Script
        id="amplitude-snippet"
        src="https://cdn.amplitude.com/script/771ef962eeb76c9a8545d7c50f9ca8f.js"
        onLoad={onLoad}
      />
    </>
  );
}
